import { combineReducers } from "redux"

import authReducer from "./auth/authReducer"
import adminUsersReducer from "./admin/users/usersReducer"
import adminStaffReducer from "./admin/staff/staffsReducer"
import infoReducer from "./info/infoReducer"
import adminServicesReducer from "./admin/services/servicesReducer"
import adminAppointmentsReducer from "./admin/appointments/appointmentsReducer"
import userAppointmentsReducer from "./appointments/appointmentsUserReducer"

const rootReducer = combineReducers({
    auth: authReducer,
    adminUsers: adminUsersReducer,
    adminStaff: adminStaffReducer,
    adminServices: adminServicesReducer,
    adminAppointments: adminAppointmentsReducer,
    info: infoReducer,
    userAppointments: userAppointmentsReducer,
})

export default rootReducer